require('./dist/angular-shims-placeholder');
module.exports = 'ng.shims.placeholder';



//////////////////
// WEBPACK FOOTER
// ./~/angular-shims-placeholder/index.js
// module id = 7
// module chunks = 2